import React, { useEffect, useState } from 'react';
import ClosedPositionsHistoryTable from './ClosedPositionsHistoryTable';
import CsvFile from '../../../utils/csv/CsvFile';
import * as PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import { useWebsocketStore } from '../../../stores/websocketStore/websocketProvider';
import AgAccountBalances from '../acctbalances/AgAccountBalances';

const closedPositionHeaders = [
  {
    label: 'symbol',
    key: 'symbol',
  },
  {
    label: 'side',
    key: 'side',
  },
  {
    label: 'realizedpnl',
    key: 'pnl',
  },
  {
    label: ' percent_pnl', //sortable: false,
    key: 'percent_pnl',
  },
  {
    label: 'costbasis',
    key: 'cost_basis', //sortable: false,
  },
  {
    label: 'quantity',
    key: 'quantity',
  },
  {
    label: 'entrydate',
    key: 'date_acquired',
  },
  {
    label: 'closedate', //sortable: false,
    key: 'date_exited',
  },
  {
    label: 'strategy',
    sortable: false,
    key: 'strategy',
  },
  {
    label: 'strategydescription',
    key: 'strategyDescription',
  },
  {
    label: 'tradePlanTemplate',
    key: 'tradePlanTemplate',
  },
  {
    label: 'accountId',
    sortable: false,
    key: 'accountId',
  },
  {
    label: 'day',
    key: 'day',
  },
];

export function ClosedPositionsCsvFile({ closedPositionsMsg }) {
  let sumPnl = 0;
  let sumCostBasis = 0;
  //console.log(closedPositionsMsg);
  let closedPositions = [];
  const replaceDelimeters = (s) => {
    if (!s) return;
    return s.replace(/\"/g, '""');
  };
  for (let id in closedPositionsMsg) {
    let closedPosition = closedPositionsMsg[id];
    closedPosition['id'] = id;
    closedPositions.push(closedPosition);
    closedPosition.percent_pnl = parseFloat(closedPosition.percent_pnl);
    closedPosition.cost_basis = parseFloat(closedPosition.cost_basis);
    sumCostBasis += closedPosition.cost_basis;

    closedPosition.pnl = parseFloat(closedPosition.pnl);
    sumPnl += closedPosition.pnl;

    closedPosition.entries = replaceDelimeters(
      JSON.stringify(closedPosition.entries)
    );
    closedPosition.exits = replaceDelimeters(
      JSON.stringify(closedPosition.exits)
    );
    closedPosition.setup = replaceDelimeters(
      JSON.stringify(closedPosition.setup)
    );
    closedPosition.lifecycle = replaceDelimeters(
      JSON.stringify(closedPosition.lifecycle)
    );
    closedPosition.setupFilters = replaceDelimeters(
      JSON.stringify(closedPosition.setupFilters)
    );
    closedPosition.options = replaceDelimeters(
      JSON.stringify(closedPosition.options)
    );
    closedPosition.orderMetrics = replaceDelimeters(
      JSON.stringify(closedPosition.orderMetrics)
    );
  }
  // console.log(closedPositions);
  return (
    <CsvFile
      data={closedPositions}
      headers={[
        {
          label: 'symbol',
          key: 'symbol',
        },
        {
          label: 'side',
          key: 'side',
        },
        {
          label: 'realizedpnl',
          key: 'pnl',
        },
        {
          label: ' percent_pnl', //sortable: false,
          key: 'percent_pnl',
        },
        {
          label: 'costbasis',
          key: 'cost_basis', //sortable: false,
        },
        {
          label: 'quantity',
          key: 'quantity',
        },
        {
          label: 'entrydate',
          key: 'date_acquired',
        },
        {
          label: 'closedate', //sortable: false,
          key: 'date_exited',
        },
        {
          label: 'strategy',
          sortable: false,
          key: 'strategy',
        },
        {
          label: 'strategydescription',
          key: 'strategyDescription',
        },
        {
          label: 'tradePlanTemplate',
          key: 'tradePlanTemplate',
        },
        {
          label: 'accountId',
          sortable: false,
          key: 'accountId',
        },
        {
          label: 'day',
          key: 'day',
        },
        {
          label: 'lifecycle',
          key: 'lifecycle',
        },
        {
          label: 'setup',
          key: 'setup',
        },
        {
          label: 'setupFilters',
          key: 'setupFilters',
        },
        {
          label: 'options',
          key: 'options',
        },
        {
          label: 'entries',
          key: 'entries',
        },
        {
          label: 'exits',
          key: 'exits',
        },
        {
          label: 'order-metrics',
          key: 'orderMetrics',
        },
      ]}
    />
  );
}

const TradeHistoryDisplays = observer(({}) => {
  const { tradeHistorySubject } = useWebsocketStore();
  const [closedPositionMsg, setClosedPositionMsg] = useState({});

  useEffect(() => {
    const subscription = tradeHistorySubject.subscribe(setClosedPositionMsg);
    return () => subscription.unsubscribe();
  }, []);

  return <ClosedPositionsHistoryTable closedPositionsMsg={closedPositionMsg} />;
});

export default TradeHistoryDisplays;
/*
export default class TradeHistoryDisplays1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {closedPositionsMsg: {}};
    }

    componentDidMount() {
        this.subscription = TradeHistorySubject.subscribe(msg => {
            this.setState({closedPositionsMsg: msg})
        });
    }

    componentWillUnmount() {
        this.subscription.unsubscribe();
    }

    render() {
        return <>
            <ClosedPositionsHistoryTable closedPositionsMsg={this.state.closedPositionsMsg}/>
        </>
    }
}*/
